import React from 'react'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import { BusyButton } from '@ztechapps/webui.button'
import { EmptyContent } from '@ztechapps/webui.util'
import { useAssetPageContext } from './Context'

/**
 * `NoMatchingAssets` renders when the original `assets` list has items but
 * the current search/filter has produced zero matches. It intentionally
 * lives inside the grid/list content area so the `DataAction` toolbar above
 * remains visible and the user can always clear their search/filter.
 *
 * This component exists to fix a stranded-toolbar bug where the previous
 * implementation replaced the entire toolbar with the "No assets yet" state
 * on an empty filtered list, leaving the user with no way to recover short
 * of a page reload.
 */
export const NoMatchingAssets = () => {
  const { localListAction } = useAssetPageContext()
  const { searchValue, tableFilter, filterTemplate, onFilter } = localListAction

  const hasSearch = !isEmpty(searchValue)
  const hasFilter = !isEmpty(tableFilter) || !isNil(filterTemplate)

  const buttonLabel = hasFilter ? 'Clear filters' : 'Clear search'

  const subMessage = hasFilter
    ? 'No assets match your current filters.'
    : hasSearch
      ? `Your search "${searchValue}" did not match any asset.`
      : 'No assets match your current filters.'

  const handleClear = () => {
    onFilter({
      tableFilter: { __reset: { value: true } },
      searchValue: '',
      searchObject: {},
    })
  }

  return (
    <EmptyContent
      icon="magnifying-glass"
      message="No matching assets"
      subMessage={subMessage}
      action={<BusyButton variant="primary" text={buttonLabel} onClick={handleClear} />}
    />
  )
}
